// import logo from './logo.svg';

// import 'assets/js/main';
import "script";

import "App.css";
import "assets/css/style.css";
import "style-general.css";

// import BetSlip from 'components/BetSlip';
import OrderForm from "components/OrderForm";
import ProductSection from "components/ProductSection";

import { BetProvider } from "context/BetContext";

// function UnverifiedUserMessage() {
//     return (
//         <div className="alert alert-warning" role="alert">
//             Your email is not verified. Please check your inbox and verify your email to access all features.
//         </div>
//     );
// }

function MainPage() {
  return (
    <>
      {/* <!-- ==== css dependencies start ==== --> */}
      {/* <link rel="stylesheet" href="../client/assets/css/style.min.css" /> */}
      {/* <link rel="stylesheet" href="../client/style-general.css" /> */}

      {/* <PagePreloader /> */}

      <div id="alert" className="d-none" role="alert"></div>

      <BetProvider>
        <ProductSection />
        {/* <BetSlip /> */}
        <OrderForm />
      </BetProvider>

      {/* <!-- ==== js dependencies start ==== --> */}
      {/* <script src="/assets/js/plugins/plugins.js"></script>
            <script src="/assets/js/plugins/plugin-custom.js"></script>
            <script src="/assets/js/main.js"></script>
            <script src="script.js"></script>
            <script src="main.js"></script> */}
    </>
  );
}

export default MainPage;
